<!-- 发送消息栏 -->
<template>
    <div>
        <pc-input
            v-if="pageSize !== 'small'"
            ref="pcInput"
            :clickItem="clickItem"
            :showVideo="showVideo"
            :pageSize="pageSize"
            :userType="userType"
            :recordTime="recordTime"
            :checkNum="checkNum"
            :action="action"
            :questNum="questNum"
            :otherSys="otherSys"
            :closedChat.sync="closedChat"
            :allQuestNum="allQuestNum"
            :groupOutTime="groupOutTime"
            :groupCreateTime="groupCreateTime"
            @sendMsg="sendMsg"
            @startVoice="startVoice"
            @goInVideo="goInVideo"
            @sendVoice="sendVoice"
            @cancelVoice="cancelVoice"
            @pictureClick="pictureClick"
            @successUpload="successUpload"
            @historyClick="historyClick"
            @copyChat="copyChat"
            @closeMultiple="closeMultiple"
        ></pc-input>
            <phone-input
            v-else
            ref="phoneInput"
            :clickItem="clickItem"
            :questNum="questNum"
            :userType="userType"
            :recordTime="recordTime"
            :patInfo="patInfo"
            :closedChat.sync="closedChat"
            :askId="askId"
            :myUserId="myUserId"
            :otherSys="otherSys"
            :groupOutTime="groupOutTime"
            :groupCreateTime="groupCreateTime"
            :allQuestNum="allQuestNum"
            @startVoice="startVoice"
            @sendVoice="sendVoice"
            @cancelVoice="cancelVoice"
            @goInVideo="goInVideo"
            @sendMsg="sendMsg"
            @cameraClick="cameraClick"
            @pictureClick="pictureClick">
            </phone-input>
        <input id="pic-input" type="file" accept="image/*" v-show="false" @change="picChooseChange"/><!--上传图片-->
        <input id="camera-input" type="file" accept="image/*" capture="camera" v-show="false" @change="picChooseChange"/><!--拍照上传图片-->
    </div>
</template>

<script>
import recordUtils from '../../libs/recordUtils/voice-utils'
import emojis from '../../assets/emojis.json'
import screenShotPlugin from 'js-web-screen-shot'
import { getQuestRemainNum, closeGroup } from '../../api/api.js'
import pcInput from './pc-input.vue'
import phoneInput from './phone-input.vue'
require('../../../static/webRecorderUtil/WebAudioRecorder.js')
// import screenShotPlugin from '../../libs/screenshotPlugin/screenShotPlugin.common.js'
// const {voiceTime, API_ROOT} = require('../../../static/config.js')
/* const config = require('../../../static/config.js')
const API_ROOT = window.httpConfig.API_ROOT
const voiceTime = window.httpConfig.voiceTime */

export default {
  name: '',
  mixins: [],
  components: { pcInput, phoneInput },
  props: {
    clickItem: {
      Object,
      default: () => {}
    },
    myUserId: {
      String,
      default: ''
    },
    API_ROOT: {
      String,
      default: ''
    },
    voiceTime: {
      Number,
      default: 0
    },
    VIDEO_URL: {
      String,
      default: ''
    },
    pageSize: {
      String,
      default: 'large'
    },
    userType: {
      Number,
      default: 0
    },
    otherSys: {
      String,
      default: ''
    },
    multipleShow: {// 是否展示多选
      Boolean,
      default: false
    },
    patInfo: {
      Object,
      default: () => {}
    },
    closedChat: {
      Boolean,
      default: false
    },
    askId: {
      String,
      default: ''
    },
    groupOutTime: {// 会话过期时长
      String,
      default: null
    },
    groupCreateTime: {// 会话创建时间
      String,
      default: null
    },
    allQuestNum: { // 提问次数
      Number,
      default: 0
    }
  },
  data () {
    return {
      microphoneShow: false,
      recordTime: this.voiceTime,
      action: this.API_ROOT + '/sysFileInfo/upload',
      emojis: emojis,
      showVideo: !!this.VIDEO_URL,
      popShow: false,
      //   multipleShow: false,
      checkNum: 0,
      showMoreBar: false,
      questNum: -1,
      isIE: false
    }
  },
  watch: {
    clickItem: {
      handler (val) {
        if (this.clickItem.type === 1 && this.clickItem.users) { // 群组
          this.clickItem.users.forEach(v => {
            if (v.userType === 2) { // 患者
              this.getQuestNum(v.id)// 获取患者剩余提问次数
            }
          })
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {},
  created () {
    this.isIE = this.$chatUtils.isIE()
  },
  mounted () {
    this.$nextTick(() => {
      this.sendByKeyup()
      this.pasteContent()
    })
    // this.initWebRecorder()
    this.judgeDownloadEvn()// 判断是微信环境还是浏览器环境
  },
  methods: {
    judgeDownloadEvn () {
      var ua = window.navigator.userAgent.toLowerCase()
      if (ua.match(/micromessenger/i) === 'micromessenger') { // 微信小程序
      // 打开微信特定页面，然后下载文件
        this.isWeiXin = true
      }
    },
    sendByKeyup () {
      // 按回车发送聊天内容
      document.getElementById('input-main').onkeyup = (event) => {
        if (event.keyCode === 13 && this.pageSize !== 'small') {
          event.preventDefault()
          this.sendMsg()
        }
        return false
      }
      document.getElementById('input-main').onkeydown = (event) => {
        if (event.keyCode === 13 && this.pageSize !== 'small') {
          event.preventDefault()
          return false
        }
      }
    },
    initWebRecorder () {
      let audioContext = new AudioContext()
      /* if (audioContext.createScriptProcessor == null) {
        audioContext.createScriptProcessor = audioContext.createJavaScriptNode
      }
      let mixer = audioContext.createGain()
      mixer.connect(audioContext.destination) */
      // eslint-disable-next-line no-undef
      this.audioRecorder = new WebAudioRecorder(audioContext, {
        workerDir: 'static/webRecorderUtil/',
        encoding: 'mp3'
      })
      // 录音完成事件，有录音返回就发送
      this.audioRecorder.onComplete = (recorder, blob) => {
        /* this.$chatUtils.blobToBase64(blob).then(val => {
          console.log('生成的base64', val)
          let params = {
            Data: val,
            Time: 30
          }
          this.sendMsg('audio', params)
        }) */
        let url = URL.createObjectURL(blob)
        this.downloadFile2(url, '语音')
      }
    },
    getQuestNum (userid) {
      let params = {
        groupid: this.clickItem.id,
        userid
      }
      getQuestRemainNum(params).then((res) => {
        this.questNum = res // -1代表无限次
      })
    },
    downloadFile2 (url, name) {
      var a = document.createElement('a')
      a.setAttribute('href', url)
      a.setAttribute('download', name)
      a.setAttribute('target', '_blank')
      let clickEvent = document.createEvent('MouseEvents')
      clickEvent.initEvent('click', true, true)
      a.dispatchEvent(clickEvent)
    },
    pasteContent () {
      // 粘贴
      const target = document.querySelector('#input-main')
      let that = this
      target.addEventListener('paste', (e) => {
        if (!(e.clipboardData && e.clipboardData.items)) {
          return
        }
        console.log('粘贴的对象', e.clipboardData.items)
        // for (var i = 0, len = e.clipboardData.items.length; i < len; i++) { // 因为会粘贴出多份所以注释
        var item = e.clipboardData.items[0]
        console.log('item', item)
        if (item.kind === 'file' && item.type.match(/^image\//i)) {
          var f = item.getAsFile()
          var reader = new FileReader()
          reader.onload = function (e) {
            let img = document.createElement('img')
            img.setAttribute('style', 'max-width:100px')
            img.setAttribute('class', 'local')
            img.setAttribute('src', e.target.result)
            document.getElementById('input-main').appendChild(img) // 将img添加到div中
            // that.insertCont(img)
          }
          reader.readAsDataURL(f) // 读取为DataURL,改为上传图片的话需要blob,方法改为readAsBinaryString,onload就会获取到blob
        } else if (item.kind === 'string' && item.type === 'text/plain') { // 普通字符串
          /* let span = document.createElement('span')
          let text = document.createTextNode(e.clipboardData.getData('text'))
          span.appendChild(text)
          document.getElementById('input-main').appendChild(span) */
          // that.insertCont(span)
          let word = e.clipboardData.getData('text')
          //   let dom = document.getElementById('input-main')
          //   dom.innerHTML += word
          that.insertCont(word)
        } else if (item.kind === 'string' && item.type === 'text/html') {
          // samesite同站策略问题，不保存图片地址了
          item.getAsString((e) => {
            // 获取到粘贴的html
            console.log('getAsString', e)
            if (e.indexOf('base64') > -1) {
              let startIndex = e.indexOf('src="') + 5
              let endIndex = e.indexOf('"', startIndex)
              let src = e.substring(startIndex, endIndex)
              let img = document.createElement('img')
              img.setAttribute('style', 'width:100px')
              img.setAttribute('class', 'online')
              img.setAttribute('src', src)
              document.getElementById('input-main').appendChild(img)
            //   that.insertCont(img)
            }
          })
        }
        // }
        e.preventDefault()

        this.$nextTick(() => {
          setTimeout(() => {
            this.moveTo() // 把光标移至最后
          }, 30)
        })
      })
    },
    sendMsg (type, params) {
      let id = this.clickItem.id
      let message = document.getElementById('input-main').innerHTML
      let inputData = {
        receiveUserId: id,
        chatReceiveType: this.clickItem.type,
        // chatType:4,
        // content: params.data,
        atUserIds: ''
      }
      if (type === 'audio') {
        // 语音文件
        inputData.chatType = 4
        inputData.content = JSON.stringify(params)
        console.log('inputData', inputData)
        this.$emit('sendMsgServer', inputData)
      } else if (type === 'file') {
        // 附件
        inputData.chatType = 2
        inputData.content = params
        console.log('inputData', inputData)
        this.$emit('sendMsgServer', inputData)
      } else if (type === 'comment') {
        // 评论
        inputData.chatType = 3
        inputData.content = JSON.stringify(params)
        console.log('inputData', inputData)
        this.$emit('sendMsgServer', inputData)
      } else if (type === 'img') { // 直接发送图片
        inputData.chatType = 1
        inputData.content = params
        console.log('inputData', inputData)
        this.$emit('sendMsgServer', inputData)
      } else if (type === 'apply') { // 应用功能消息
        inputData.chatType = 8
        inputData.content = JSON.stringify(params)
        console.log('inputData', inputData)
        this.$emit('sendMsgServer', inputData)
      } else {
        // 其他数据
        if (
          message == null ||
          message === '' ||
          message === '<div><br></div>' ||
          message === '<div><br></div><div><br></div>'
        ) {
          this.$message.warning('不能发送空白信息')
          document.getElementById('input-main').innerHTML = '' // 清空一下消息
          return
        }
        message = message.replace(/<p>|<\/p>|<div>|<\/div>/g, '') // 去除掉回车带来的换行
        // let reg = new RegExp('<img style="[^"]+"[^>]*>', 'g')
        let reg = new RegExp('<img .*?>', 'g')
        console.log('获得的数据', message)
        let strArr = message.split(reg) // 处理文字中夹杂的图片
        console.log('处理出来的文字', strArr)
        // 发送文字
        for (let str of strArr) {
          if (str) {
            inputData.chatType = 0
            str = this.replaceAndModifyUrls(str, (url) => {
              return `<a href="${url}" target="_blank">${url}</a>`
            })// url链接拼接上<a>标签</a>
            inputData.content = this.emojiToStr(str) // 是否为表情可转换编码
            // inputData.content = str
            console.log('发送文字', str, inputData) //
            this.$emit('sendMsgServer', inputData)
          }
        }
        // 发送图片-base64
        let imgLocalNodes = document.querySelectorAll('#input-main .local')
        imgLocalNodes.forEach((e) => {
          let base64 = e.getAttribute('src')
          base64 = base64.replace('data:image/png', 'data:image/jpeg')
          base64 = base64.replace('data:image/gif', 'data:image/jpeg')
          inputData.chatType = 1
          inputData.content = base64
          console.log('base64的图片', inputData)
          this.$emit('sendMsgServer', inputData)
        })

        // 发送图片-在线图片
        let imgInlineNodes = document.querySelectorAll('#input-main .online')
        imgInlineNodes.forEach((e) => {
          let url = e.getAttribute('src')
          //   let img = `<img style="max-width:200px;width:auto;height:auto" src="${url}"/>`
          inputData.chatType = 1
          inputData.content = url
          console.log('网上的图片', inputData)
          this.$emit('sendMsgServer', inputData)
        })

        // 发送完毕消息清空输入框
        document.getElementById('input-main').innerHTML = ''
      }
    },
    replaceAndModifyUrls (text, modifyFn) { // 查找url函数
      // 正则表达式匹配大部分URL
      const urlRegex = /(\bhttps?:\/\/[^\s]+(\b|$))/gi

      // 这个函数会被用来修改找到的URL
      function modifyMatchedUrl (match) {
        // 这里可以根据需要对URL进行任何处理
        // modifyFn 是一个函数，接受原始的URL作为参数并返回修改后的URL
        return modifyFn(match)
      }

      // 替换发现的所有URL为经过modifyFn处理后的URL
      return text.replace(urlRegex, modifyMatchedUrl)
    },
    questNumFunc () {
      if (this.clickItem.type === 1 && this.questNum > 0) {
        this.questNum--
        if (this.questNum === 0 && this.userType === 0) { // 没有次数了需要主动结束会话  患者端发起
          // ----2025-03-27 次数到了也不结束会话。因为需要医生能继续发送消息。后端会对患者做次数限制判断
          /*  let params = {
            groupId: this.clickItem.id,
            userId: this.myUserId
          }
          closeGroup(params).then(data => {
            this.$emit('update:closedChat', true)
          }) */
        }
      }
    },
    emojiToStr (val) {
      // 表情转换编码
      for (const key in emojis) {
        // eslint-disable-next-line no-undef
        const el = emojis[key]
        // val = val.replaceAll(el.char, el.keywords)
        let reg = new RegExp(el.char, 'g')
        val = val.replace(reg, el.keywords) // 去除掉回车带来的换行
      }
      return val
    },
    startVoice () {
      recordUtils.onStartVoice((time) => {
        this.recordTime = time
        if (this.recordTime === 0) {
          // 倒计时结束就自动发送语音
          this.sendVoice()
        }
      })
    },
    goInVideo () {
      // 发起视频
      /* // 先调起api获取token
      getVideoToken().then(res => {
        if (res) {
          let token = res
          let roomId = this.$chatUtils.getUid()
          let userId = this.myUserId
          let url = `http://192.168.0.91:9424/chatJoin?token=${token}&room_id=${roomId}&user_id=${userId}`
          let videoWindow = window.open(url, '', 'width=600,height=500,titlebar=no,location=no,top=200,left=500,toolbar=no')
          videoWindow.focus()
        }
      }) */
      if (this.userType === 0) { // 患者不给视频
        this.$message.error('该功能暂未开放')
      } else {
        this.$emit('goInVideo')
      }
    },
    sendVoice () {
      // 结束语音并发送语音
      this.microphoneShow = false
      recordUtils.onEndVoice((params) => {
        // console.log('params', params)
        this.sendMsg('audio', params)
        // let url = URL.createObjectURL(params)
        // this.downloadFile2(url, '语音')
      })
      /* this.audioRecorder.finishRecording()
      console.log('3333333333333') */
    },
    cancelVoice () {
      recordUtils.stop()
    },
    pictureClick () {
      // 图片click
      document.getElementById('pic-input').click()
    },
    cameraClick () {
    //   if (this.isWeiXin) { // 调用微信唤起方法
      // eslint-disable-next-line no-undef
      /* let cameraContext = wx.createCameraContext()
        cameraContext.takePhoto({// 获取图片
          quality: 'high', // 高画质
          success: (res) => {
            this.sendImg(res.tempImagePath)
          },
          fail: () => {
            this.$message.error('获取图片失败')
          }
        }) */
      // eslint-disable-next-line no-undef
    //     wx.chooseImage({
    //       count: 1,
    //       sizeType: ['original', 'compressed'],
    //       sourceType: ['album', 'camera'],
    //       success: function (res) {
    //         this.sendImg(res.tempImagePath)
    //       }
    //     })
    //   } else { // h5直接调用
      document.getElementById('camera-input').click()
    //   }
    },
    picChooseChange (e) {
      // 图片选择
      this.sendImg(e.target.files[0])
      document.getElementById('pic-input').value = ''
      document.getElementById('camera-input').value = ''
    },
    sendImg (url) { // 发送图片文件
      var reader = new FileReader()
      reader.onload = (e) => {
        if (this.pageSize !== 'small') {
          const str =
            "<img style='max-width:100px' class='local' src='" +
            e.target.result +
            "'/>"
          let ele = document.querySelector('#input-main')
          ele.innerHTML = ele.innerHTML + str
        } else {
        //   alert(e.target.result)
          let base64 = e.target.result
          console.log('base64', base64)
          base64 = base64.replace('data:image/png', 'data:image/jpeg')
          base64 = base64.replace('data:image/gif', 'data:image/jpeg')

          this.sendMsg('img', base64)
        }
      }
      reader.readAsDataURL(url)
    },
    fileClick () {
      document.getElementById('file-input').click()
    },
    handleChange (file, fileList) {
      this.uploadFile = null
      /*  if (file.status === 'ready') {
        if (file.name.indexOf('.txt') > -1) {
          this.$chatUtils.txt2utf8(file.raw, (blob) => {
            let newFile = this.$chatUtils.blobToFile(blob, file.name, 'text/plain')
            this.uploadFile = newFile
            this.$refs.upload.submit()
          })
        } else {
          this.uploadFile = file
        }
      } */
      /* var _this = this
      if (file.raw) {
        let reader = new FileReader()
        reader.onload = function (e) {
          _this.contentHtml = e.target.result
          console.log('e.target.result', e.target.result)
        }
        reader.readAsText(file.raw, 'utf8')
      }
      console.log(file, fileList) */
    },
    /*  uploadRequest (param) {
      // 手动上传文件
      if (this.uploadFile) {
        uploadFileApi({ file: this.uploadFile }).then((data) => {
          this.sendMsg('file', JSON.stringify(data))
        })
      }
    }, */
    successUpload (response, file, fileList) {
      if (response.statusCode === 200) {
        this.sendMsg('file', JSON.stringify(response.data))
      } else {
        this.$message.error(response.errors)
      }
    },
    smileSpanClick () {},
    // 向聊天框填入表情
    setEmoji (char) {
      //   let node = document.createElement('img')
      //   node.setAttribute('src', require(`../assets/emoji/${number}.gif`))
      document.getElementById('input-main').innerHTML += char
      //   this.insertCont(char)
      this.popShow = false
    },
    screenShoot () {
      // 截图
      // eslint-disable-next-line no-new
      new screenShotPlugin({
        enableWebRtc: false,
        completeCallback: this.screenShootCallBack
      })
    },
    screenShootCallBack (base64) {
      // 把图片放到粘贴板里
      let node = document.createElement('img')
      node.setAttribute('style', 'max-width:100px')
      node.setAttribute('src', base64)
      node.setAttribute('class', 'local')
      // 把图片放到输入框里
      document.getElementById('input-main').appendChild(node) // 将img添加到div中

      this.$nextTick(() => {
        this.moveTo() // 把光标移至最后
      })

      // 复制图片节点
      let img2 = document.createElement('img')
      img2.setAttribute('style', 'width:100px;position: fixed; top: -5000px;')
      img2.setAttribute('src', base64)
      img2.setAttribute('class', 'screenShotImg')

      document.body.appendChild(img2)

      let target2 = document.querySelector('.screenShotImg')
      this.getSelect(target2)
      document.execCommand('copy')
      document.body.removeChild(target2)
    },
    // 选中图片
    getSelect (targetNode) {
      if (window.getSelection) {
        // chrome等主流浏览器
        let selection = window.getSelection()
        let range = document.createRange()
        range.selectNode(targetNode)
        selection.removeAllRanges()
        selection.addRange(range)
      } else if (document.body.createTextRange) {
        // ie
        let range = document.body.createTextRange()
        range.moveToElementText(targetNode)
        range.select()
      }
    },
    historyClick () {
      this.$emit('historyClick')
    },
    moreClick () {
      // 更多工具
      this.showMoreBar = !this.showMoreBar
    },
    openLickClick () {
      // 开单
    },
    moveTo (type = 'end') {
      // 移动光标到最后面
      let el = document.getElementById('input-main')
      el.focus()
      if (window.getSelection) {
        // ie11 10 9 ff safari
        let range = window.getSelection() // 创建range
        range.selectAllChildren(el) // 选择el子项
        if (type === 'start') {
          range.collapseToStart() // 光标移至开头
        } else {
          range.collapseToEnd() // 光标移至最后
        }
      } else if (document.selection) {
        // ie10 9 8 7 6 5
        let range = document.selection.createRange() // 创建选择对象
        range.moveToElementText(el) // range定位到ele
        if (type === 'start') {
          range.collapse() // 光标移至开头
        } else {
          range.collapse(false) // 光标移至最后
        }
        range.select()
      }
    },
    insertCont (html) {
      // 在光标处插入内容
      let el = document.getElementById('input-main')
      el.focus()
      if (document.selection) {
        // IE 10,9,8,7
        document.selection.createRange().pasteHTML(html)
      } else if (window.getSelection) {
        var sel = window.getSelection()
        if (sel.getRangeAt && sel.rangeCount) {
          var range = sel.getRangeAt(0)
          range.deleteContents()
          var div = document.createElement('div')
          div.innerHTML = html
          let frag = document.createDocumentFragment()
          let node
          let lastNode
          while ((node = div.firstChild)) {
            lastNode = frag.appendChild(node)
          }
          range.insertNode(frag)
          if (lastNode) {
            range = range.cloneRange()
            range.setStartAfter(lastNode)
            range.collapse(true)
            sel.removeAllRanges()
            sel.addRange(range)
          }
        }
      }
    },
    copyChat () {
      this.$emit('copyChat')
      this.closeMultiple()
    },
    closeMultiple () {
      this.$emit('closeMultiple')
    }
  },
  beforeDestroy () {},
  destroyed () {},
  beforeUpdate () {},
  updated () {}
}
</script>
<style>
.emoji-pop {
  width: auto !important;
  max-width: 400px;
}
</style>
<style lang='scss' scoped>

</style>



// WEBPACK FOOTER //
// packages/chat/src/input-send.vue